import Tools from './tools';
export default class Nav {
    constructor() {
        // Nav
        this.nav = document.querySelector('nav.nav');
        if(!this.nav) {
            return false;
        }

        this.position();
        this.burger();
        this.responsive();

        window.addEventListener('resize', () => {
            this.responsive();
        });
    }

    position() {
        window.addEventListener('scroll', () => {
            if(window.pageYOffset > this.nav.offsetHeight) {
                this.nav.classList.add('js-fixed');
            } else {
                this.nav.classList.remove('js-fixed');
            }
        });
    }

    burger() {
        const btn = document.querySelector('.nav .burger');
        const menu = document.querySelector('.nav .menu');

        if(btn && menu) {
            btn.addEventListener('click', () => {
                menu.classList.toggle('js-open');
                btn.classList.toggle('js-open');
                if(menu.classList.contains('js-open')) {
                    Tools.freezeScroll();
                } else {
                    Tools.freeScroll();
                }
            });
        }
    }

    responsive() {
        if(window.innerWidth < 1024) {
            const btns = document.querySelectorAll('.nav .menu__item.menu-item-has-children > .menu__link');
            if(btns.length > 0) {
                btns.forEach((btn) => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        if(document.querySelector('.nav .menu__item.menu-item-has-children.js-open') && btn.parentElement != document.querySelector('.nav .menu__item.menu-item-has-children.js-open')) {
                            Tools.autoToFixed(document.querySelector('.nav .menu__item.menu-item-has-children.js-open .menu__sub'));
                            document.querySelector('.nav .menu__item.menu-item-has-children.js-open').classList.remove('js-open');
                        }

                        if(btn.parentElement.classList.contains('js-open')) {
                            btn.parentElement.classList.remove('js-open');
                            Tools.autoToFixed(btn.nextElementSibling);
                        } else {
                            btn.parentElement.classList.add('js-open');
                            Tools.fixedToAuto(btn.nextElementSibling);
                        }
                    });
                });
            }
        } else {
            // Suppression des hauteurs ajoutées en JS en mobile.
            const submenus = document.querySelectorAll('.nav .menu__sub');
            if(submenus.length > 0) {
                submenus.forEach((menu) => {
                    menu.style.height = null;
                    menu.parentElement.classList.remove('js-open');
                });
            }
        }
    }
}